import { onMounted, onUnmounted } from 'vue';
import { useAppStore } from '../stores/app';

export function useScrollHandler() {
  const appStore = useAppStore();

  function handleScroll() {
    const scrollY = window.scrollY;
    appStore.updateScrollState(scrollY);

    const sections = ['home', 'about', 'skills', 'projects', 'blog', 'contact'];
    for (const section of sections) {
      const element = document.getElementById(section);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top <= 150 && rect.bottom >= 150) {
          appStore.setActiveSection(section);
          break;
        }
      }
    }
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });

  return {};
}
